export default __webpack_public_path__ + "static/media/kg10.d58562fa.jpg";